// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wp":"wp-2uSntuLb","img":"img-3vnyDAiE","text":"text-1aaLBS54","title":"title-rp5Zo6Mv","rank":"rank-8K1XBGv7","play":"play-18oLMAxE"};